import { PageCriteria } from 'src/app/_models/page-criteria';

export class PolicyCriteria  extends PageCriteria{
}
